import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  FormControl,
  Input,
  FormLabel,
  useToast,
  FormHelperText,
  Select as ChakraSelect,
} from "@chakra-ui/react";
import Select from "react-select";
import BookingDataService from "../../services/Booking";
import React, { useEffect, useState } from "react";
import { Spinner } from "@chakra-ui/react";

import { DateTime } from "luxon";
export default function MonthlyDownloadSheet({ isOpen, onClose }: any) {
  const toast = useToast();
  const token = localStorage.getItem("logged_in_user_token");
  const [downloadLoader, setdownloadLoader] = useState<any>(false);

  const [selectedValue, setSelectedValue] = useState("");
  const initialRef = React.useRef(null);

  const generateMonthYearArray = () => {
    try {
      const startDate = DateTime.fromObject({
        month: DateTime.fromFormat("June", "LLLL").month,
        year: 2024,
      });
      const endDate = DateTime.now();
      let currentDate = startDate;
      const monthYearArray = [];
      let i = 0;
      while (currentDate <= endDate) {
        monthYearArray.push({
          month: currentDate.toFormat("LLLL"),
          year: currentDate.year,
          text: `${currentDate.toFormat("LLLL")}-${currentDate.year}`,
          index: i.toString(),
        });
        currentDate = currentDate.plus({ months: 1 });
        i++;
      }

      return monthYearArray;
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  const handleSubmit = () => {
    setdownloadLoader(true);
    const selectedMonth = generateMonthYearArray().find(
      (el) => el.index === selectedValue
    );
    BookingDataService.downloadExpertsMonthlyBiling(
      selectedMonth?.month,
      selectedMonth?.year
    )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${selectedMonth?.month}-${selectedMonth?.year}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast({
          position: "top",
          title: "Billing Sheet Downloaded Successfully",
          description: "The billing sheet has been downloaded successfully",
          status: "success",
          duration: 1500,
          isClosable: true,
        });
      })
      .catch((error) => {
        console.error("Error downloading payments:", error.message);
        toast({
          position: "top",
          title: "Billing Sheet Download Failed",
          description:
            "There was an error downloading the billing sheet. Please try again later.",
          status: "error",
          duration: 1500,
          isClosable: true,
        });
      })
      .finally(() => {
        setdownloadLoader(false);
        setSelectedValue("")
        onClose();
      });
  };

  const handleSelecion = (value: any) => {
    setSelectedValue(value);
  };

  return (
    <>
      <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Select Month</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl mt={5}>
              <ChakraSelect
                value={selectedValue}
                onChange={(e) => handleSelecion(e.target.value)}
              >
                <option value="">Choose Month</option>
                {generateMonthYearArray().map((el) => (
                  <option value={el.index}>{el.text}</option>
                ))}
              </ChakraSelect>
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button
              bgColor="#327171"
              color={"white"}
              mr={3}
              onClick={handleSubmit}
            >
              {downloadLoader ? <Spinner size="sm" /> : "Download"}
            </Button>
            <Button bgColor="red" color={"white"} onClick={onClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
